/**
 * @file Renders the authenticator screen's platform footer.
 */
import { W3 } from "@components/Constants";
import { PlatformFooter } from "@components/Page";

/**
 * Renders the platform footer below the authenticator forms.
 */
const Footer = (): JSX.Element | null => {
  return (
    <PlatformFooter
      marginTop={W3}
      shouldRenderOnMobile={true}
    />
  );
};

export default Footer;
